import { Skeleton } from '@/components/skeleton/skeleton'

import { cn } from '@/lib/utils'

export const ApplicantCaseEoirDetailLoading = () => {
  return (
    <div className={cn('mx-5 my-6', 'flex flex-col gap-3')}>
      <Skeleton className="h-8 w-1/3" />
      <Skeleton className="mb-3 h-6 w-2/3" />
      <Skeleton className="h-[70px] w-full" />
      <Skeleton className="h-[70px] w-full" />
      <Skeleton className="h-[70px] w-full" />
      <Skeleton className="h-[70px] w-full" />
    </div>
  )
}
